import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import NoPage from './pages/NoPage'
import './global.css'
import Vehicles from './pages/Vehicles'
import PrivateRoute from './components/PrivateRoute'
import Importers from './pages/Importers'
import Store from './context/global_context'
import DtcApp from './pages/vehicles/dtcs'
import TatDtcMappings from './pages/vehicles/dtcs/TaTmappings'
import DtcEdit from './pages/vehicles/dtcs/DtcEdit'
import TatConnectorMapping from './pages/vehicles/dtcs/TaTmappings/ConnectorMapping'
import ConnectorViews from './pages/vehicles/connector_views'
import ConnectorViewEdit from './pages/vehicles/connector_views/edit'
import ConnectorViewNew from './pages/vehicles/connector_views/new'
import ConnectorViewEditMappings from './pages/vehicles/connector_views/edit_mappings'
import Administration from './pages/administration'
import EditVehicle from './pages/vehicles/edit'
import CreateNewVehicle from './pages/vehicles/new'
import PowerDistributions from './pages/vehicles/power_distributions'
import Auth from './pages/auth'
import NotPermitted from './pages/not_permitted'
import LogoutSuccess from './pages/logout_success'
import SystemAndSubSystem from './pages/system_and_sub_system'
import Plugin from './pages/vehicles/plugin'
import InlinesConnections from './pages/vehicles/inlines'
import ModulesPage from './pages/vehicles/modules'
import DevicePage from './pages/vehicles/devices'
import InSpectionPointsPage from './pages/vehicles/inspection_points'
import WirePage from './pages/vehicles/wire'
import ConnectorPage from './pages/vehicles/connector'
import SalesCodesPage from './pages/vehicles/sales_code'
import FunctionalDiagramPage from './pages/vehicles/functional_diagram'
import HarnessListPage from './pages/vehicles/harness_list'
import CircuitPage from './pages/vehicles/circuit'
import FunctionalDiagramEditPage from './pages/vehicles/functional_diagram/edit'
import ConnectorViewMappingsPrintPage from './pages/vehicles/connector_views/print'
import NotFound from './pages/404'
import CreateDtcForm from './components/dtcs/TATMappings/DtcEdit/CreateDtcForm'
import DeviceConnectionPage from './pages/vehicles/device_connections'
import DtcMappingErrorsPage from './pages/vehicles/dtc_mapping_errors'
import GraphMissingImagesPage from './pages/vehicles/graph_missing_images'
import UsageReport from './pages/usage_report'
import PromoteChangesPage from './pages/promote_changes'
import TracerPreviewPage from './pages/promote_changes/tracer_preview'
import DeletePromotedChangesPage from './pages/promote_changes/delete'
import VisualAidPage from './pages/vehicles/visual_aids'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Store>
              <Layout />
            </Store>
          }
          key={'home'}
        >
          <Route path="users/sign_in" index element={<Login />} key={'login'} />
          <Route path={`auth/`} element={<Auth />} key={'auth'} />
          <Route
            path="not_permitted/"
            element={<NotPermitted />}
            key={'not_permitted'}
          />
          <Route
            path="logout_success/"
            element={<LogoutSuccess />}
            key={'logout_success'}
          />
          <Route exact element={<PrivateRoute />}>
            <Route path="vehicles/" element={<Vehicles />} key={'vehicles'} />
            <Route
              path="vehicles/:vehicle/edit"
              element={<EditVehicle />}
              key={'vehicles_edit'}
            />
            <Route
              path="vehicles/new"
              element={<CreateNewVehicle />}
              key={'vehicles_create'}
            />

            <Route
              path={`vehicles/:vehicle/importers`}
              element={<Importers />}
              key={'vehicle_importers'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs`}
              element={<DtcApp />}
              key={'dtcs'}
            />
            <Route
              path={`vehicles/:vehicle/plugin`}
              element={<Plugin />}
              key={'def_plugin'}
            />
            <Route
              path={`vehicles/:vehicle/inlines`}
              element={<InlinesConnections />}
              key={'inlines'}
            />
            <Route
              path={`vehicles/:vehicle/power_distributions`}
              element={<PowerDistributions />}
              key={'power_distributions'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/mappings`}
              element={<TatDtcMappings />}
              key={'tat_dtcs_mappings'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/:dtc_id/edit`}
              element={<DtcEdit />}
              key={'tat_dtc_edit'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/new`}
              element={<CreateDtcForm />}
              key={'tat_dtc_new'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/mappings/:connector_id`}
              element={<TatConnectorMapping />}
              key={'tat_dtcs_connector_mappings'}
            />
            <Route
              path={`vehicles/:vehicle/connector_views`}
              element={<ConnectorViews />}
              key={'connector_views'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/new`}
              element={<ConnectorViewNew />}
              key={'connector_views_new'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/:connector_view/edit`}
              element={<ConnectorViewEdit />}
              key={'connector_views_edit'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/:connector_view/edit_mappings`}
              element={<ConnectorViewEditMappings />}
              key={'connector_views_edit_mappings'}
            />

            <Route
              path={`administration/`}
              element={<Administration />}
              key={'administration'}
            />

            <Route
              path={`system_and_sub_system/`}
              element={<SystemAndSubSystem />}
              key={'system_and_sub_system'}
            />
            <Route
              path={`vehicles/:vehicle/modules`}
              element={<ModulesPage />}
              key={'modules'}
            />
            <Route
              path={`vehicles/:vehicle/devices`}
              element={<DevicePage />}
              key={'devices'}
            />
            <Route
              path={`vehicles/:vehicle/inspection_points`}
              element={<InSpectionPointsPage />}
              key={'inspection_points'}
            />
            <Route
              path={`vehicles/:vehicle/wire`}
              element={<WirePage />}
              key={'wires'}
            />
            <Route
              path={`vehicles/:vehicle/connector`}
              element={<ConnectorPage />}
              key={'connector'}
            />
            <Route
              path={`vehicles/:vehicle/sales_code`}
              element={<SalesCodesPage />}
              key={'sales_code'}
            />
            <Route
              path={`vehicles/:vehicle/functional-diagram`}
              element={<FunctionalDiagramPage />}
              key={'functional_diagram'}
            />
            <Route
              path={`vehicles/:vehicle/harnesses`}
              element={<HarnessListPage />}
              key={'harnesses'}
            />
            <Route
              path={`vehicles/:vehicle/circuit`}
              element={<CircuitPage />}
              key={'circuit'}
            />
            <Route
              path={`vehicles/:vehicle/functional-diagram/:functional`}
              element={<FunctionalDiagramEditPage />}
              key={'functional_diagram_edit'}
            />
            <Route
              path={`vehicles/:vehicle/connector_views/:connector_view/print`}
              element={<ConnectorViewMappingsPrintPage />}
              key={'connector_views_print'}
            />
            <Route
              path={`vehicles/:vehicle/device_connections`}
              element={<DeviceConnectionPage />}
              key={'device_connections'}
            />
            <Route
              path={`vehicles/:vehicle/dtc_mapping_validation`}
              element={<DtcMappingErrorsPage />}
              key={'dtc_mapping_errors'}
            />
            <Route
              path={`vehicles/:vehicle/graph_missing_images`}
              element={<GraphMissingImagesPage />}
              key={'graph_missing_images'}
            />
            <Route
              path={`usage_report/`}
              element={<UsageReport />}
              key={'usage_report'}
            />
            <Route
              path={`manage-update-list/`}
              element={<PromoteChangesPage />}
              key={'manage_update_list'}
            />
            <Route
              path={`manage-update-list/preview`}
              element={<TracerPreviewPage />}
              key={'manage_update_list_preview'}
            />
            <Route
              path={`manage-update-list/:branch/:vehicle/delete`}
              element={<DeletePromotedChangesPage />}
              key={'delete_manage_update_list'}
            />
            <Route
              path={`vehicles/:vehicle/visual-aid`}
              element={<VisualAidPage />}
              key={'visual_aid'}
            />
            <Route path="*" element={<NotFound />} key={'no_page'} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
